import { useContext, useEffect, useState } from "react";
import {
  FaAward,
  FaBatteryFull,
  FaGlobe,
  FaShieldAlt,
  FaUsers,
  FaHandshake,
  FaStoreAlt,
  FaUserTie,
  FaBuilding,
  FaBriefcase,
  FaStore,
  FaUser,
  FaMousePointer,
  FaUserCheck,
  FaSignInAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { AuthContext } from "../context";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const navigate = useNavigate();
  const { openAccountModal } = useContext(AuthContext);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
      } catch (err) {
        console.error("Home data error:", err);
        setError(err.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  /* ================= COMPANY LOGOS ================= */

  const companies = [
    { imgSrc: "/company/1a.png" },
    { imgSrc: "/company/1b.png" },
    { imgSrc: "/company/1c.png" },
    { imgSrc: "/company/1d.png" },
    { imgSrc: "/company/2.png" },
    { imgSrc: "/company/3.png" },
    { imgSrc: "/company/4.png" },
    { imgSrc: "/company/5.png" },
    { imgSrc: "/company/6.png" },
    { imgSrc: "/company/7.png" },
    { imgSrc: "/company/8.png" },
    { imgSrc: "/company/9.png" },
    { imgSrc: "/company/10.png" },
    { imgSrc: "/company/11.jpeg" },
    { imgSrc: "/company/12.jpeg" },
    { imgSrc: "/company/13.jpeg" },
  ];

  /* ================= BANNERS ================= */

  const banners = [
    { url: "/banner/banner21.jpeg" },
    { url: "/banner/banner22.jpeg" },
    { url: "/banner/banner23.jpeg" },
    { url: "/banner/dehk.jpeg" },
    { url: "/banner/dmek.png" },
    { url: "/banner/diagnosis1.png" },
    { url: "/banner/brs1.png" },
    { url: "/banner/brs2.png" },
    { url: "/banner/brs3.png" },
    { url: "/banner/brs4.jpeg" },
  ];

  /* ================= PRIME CATEGORIES ================= */

  const primeCategories = [
    {
      title: "Sleep Apnea",
      products: "Sleep Apnea Products",
      image: "/medical-categories/sleep-apnea.png",
      link: "/medical-devices/sleep-apnea",
    },
    {
      title: "Hospital Equipment",
      products: "Hospital Equipment",
      image: "/medical-categories/hospital-equipment.png",
      link: "/medical-devices/hospital-equipment",
    },
    {
      title: "Device Accessories",
      products: "Device Accessories",
      image: "/medical-categories/device-accessories.png",
      link: "/medical-devices/device-accessories",
    },
    {
      title: "Hospital Consumables",
      products: "Hospital Consumables",
      image: "/medical-categories/hospital-consumables.png",
      link: "/medical-devices/hospital-consumables",
    },
  ];

  /* ================= SLIDER SETTINGS ================= */

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    pauseOnHover: false,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings2 = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const bannerSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    adaptiveHeight: false,
  };

  /* ================= FAQ ================= */

  const faqs = [
    {
      q: "What is LifeOnPlus?",
      a: "LifeOnPlus is a complete digital healthcare ecosystem offering medical products, diagnostics, wellness services, and smart health technology.",
    },
    {
      q: "How does the Global Digital Health Smart Card work?",
      a: "It stores your medical records digitally. Doctors can scan the QR code to access your health history instantly during emergencies.",
    },
    {
      q: "What services can I access on LifeOnPlus?",
      a: "Health products, lab tests, doctor consultations, wellness therapies, insurance, and digital health tools — all in one place.",
    },
    {
      q: "Is my health data secure?",
      a: "We use strong security practices to help protect your personal health information.",
    },
    {
      q: "Can I become a partner or franchise?",
      a: "Yes. We offer channel partner, virtual partner, and franchise opportunities across India and globally.",
    },
    {
      q: "Do you offer home services?",
      a: "Yes. Many diagnostic tests, wellness therapies, and consultations are available with home collection or doorstep delivery.",
    },
  ];

  /* ================= TESTIMONIALS ================= */

  const testimonial = [
    {
      profession: "Tamil Actor",
      name: "Sharath Kumar",
      imgSrc: "/testimonials/user-1.jpeg",
      detail: "Innovative Product",
    },
    {
      profession: "Member of Lok Sabha",
      name: "Annasaheb Shankar Jolle",
      imgSrc: "/testimonials/user-2.jpeg",
      detail:
        "Highly advanced Medical & Digital Health Technology, I have seen the demo & appreciated, getting aligned with this company",
    },
    {
      profession:
        "BBM - Founder & Chairman of United Medicare Pte Ltd, Singapore",
      name: "Robin NG",
      imgSrc: "/testimonials/user-3.jpeg",
      detail: "Very Good Medical Technology and Devices",
    },
    {
      profession: "Former Education Minister",
      name: "Suresh Kumar",
      imgSrc: "/testimonials/user-4.jpeg",
      detail: "Excellent Medical Health Technology",
    },
    {
      profession: "Actress, Bangalore",
      name: "Ragini Dwivedi",
      imgSrc: "/testimonials/user-5.jpeg",
      detail:
        "Having spent many years on research and development on innovative medical technology. Finally we got a very good product for human beings. I wish Mr. Rajanikanth and his team great success.",
    },
    {
      profession: "National University of Singapore",
      name: "Cynthia Chan",
      imgSrc: "/testimonials/user-6.jpeg",
      detail: "New Medical & Innovative Idea",
    },
  ];

  /* ================= SERVICES ================= */

  const services = [
    {
      title: "Digital Emergency Health Kit",
      desc: "Instant access to medical records & emergency support anywhere",
      img: "/services-images/dehk.jpeg",
      link: "/services/1",
    },
    {
      title: "Digital & Medical Emergency Kit",
      desc: "Advanced health monitoring with real-time alerts and SOS",
      img: "/services-images/dmek.png",
      link: "/services/15",
    },
    {
      title: "Diagnosis Services",
      desc: "Accurate medical testing with instant digital reports",
      img: "/services-images/diagnosis1.jpeg",
      link: "/services/4",
    },
    {
      title: "Quick Health Checkup",
      desc: "Comprehensive body health assessment in minutes",
      img: "/services-images/qhc1.jpeg",
      link: "/services/14",
    },
    {
      title: "Express Medical Test",
      desc: "Fast & reliable diagnostic services at your convenience",
      img: "/services-images/emt2.png",
      link: "/services/3",
    },
    {
      title: "Body Recharge Station",
      desc: "Advanced wellness and recovery solutions",
      img: "/services-images/brs1.jpeg",
      link: "/services/5",
    },
  ];

  /* ================= MEMBERSHIP ================= */

  const membershipPlans = [
    {
      name: "BASIC",
      price: "₹300",
      color: "#35A93E",
      light: "#effbf1",
    },
    {
      name: "BRONZE",
      price: "₹600",
      color: "#d97706",
      light: "#fff7ed",
    },
    {
      name: "BRONZE PLUS",
      price: "₹1,000",
      color: "#6b3a24",
      light: "#faf4f0",
    },
    {
      name: "SILVER",
      price: "₹1,500",
      color: "#64748b",
      light: "#f8fafc",
    },
  ];

  /* ================= ACCOUNT ROLES ================= */

  const roles = [
    {
      title: "Member",
      icon: <FaUsers />,
      desc: "Purchase healthcare products, manage memberships, and access exclusive member benefits.",
      color: "#02BE0F",
      bg: "#e9f9ee",
    },
    {
      title: "Channel Partner",
      icon: <FaHandshake />,
      desc: "Expand your business by promoting LifeOnPlus products and earning attractive commissions.",
      color: "#0d6efd",
      bg: "#e7f1ff",
    },
    {
      title: "Franchise",
      icon: <FaStoreAlt />,
      desc: "Own and operate a LifeOnPlus franchise while delivering healthcare services locally.",
      color: "#8b5cf6",
      bg: "#f3e8ff",
    },
    {
      title: "Channel Partner Plus",
      icon: <FaUserTie />,
      desc: "Unlock premium partnership benefits with higher rewards, incentives, and business revenue sharing.",
      color: "#ff9800",
      bg: "#fff4e5",
    },
    {
      title: "Corporate",
      icon: <FaBuilding />,
      desc: "Corporate employee wellness solutions for businesses, industries, and professionals.",
      color: "#6f42c1",
      bg: "#f3e8ff",
    },
    {
      title: "Director",
      icon: <FaBriefcase />,
      desc: "Manage partner networks, oversee operations, and drive regional business growth.",
      color: "#343a40",
      bg: "#f5f5f5",
    },
    {
      title: "Vendor",
      icon: <FaStore />,
      desc: "Sell healthcare products through our marketplace and manage your online business.",
      color: "#20c997",
      bg: "#e6fffa",
    },
    {
      title: "End User",
      icon: <FaUser />,
      desc: "Explore healthcare products, wellness services, and digital health solutions with ease.",
      color: "#6c757d",
      bg: "#f8f9fa",
    },
  ];

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="h-14 w-14 border-4 border-[#47b250] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <p className="text-center text-red-600 mt-10">
        Error: {error}
      </p>
    );
  }

  return (
    <>
      <style>{`
        .testimonial-slider .slick-list {
          height: auto !important;
        }

        .testimonial-slider .slick-track {
          display: flex !important;
          align-items: stretch;
        }

        .testimonial-slider .slick-slide {
          height: 100% !important;
          display: flex !important;
        }

        .testimonial-slider .slick-slide > div {
          height: 100% !important;
          width: 100% !important;
        }

        .testimonial-card {
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .membership-card {
          height: 155px;
          min-height: 155px;
          max-height: 155px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .membership-card:hover {
          transform: translateY(-3px);
        }

        .membership-card .membership-content {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .membership-button {
          transition: all 0.25s ease;
        }

        .membership-button:hover {
          transform: translateY(-1px);
        }

        .benefit-table {
          width: 100%;
          min-width: 800px;
        }

        .benefit-wrapper {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        .benefit-cell {
          padding: 7px 6px;
          border-bottom: 1px solid #e5e7eb;
          font-size: 11px;
          line-height: 1.3;
        }

        .prime-category-card {
          transition: all 0.3s ease;
        }

        .prime-category-card:hover {
          transform: translateY(-5px);
        }

        @media (max-width: 640px) {
          .membership-card {
            height: 155px;
            min-height: 155px;
            max-height: 155px;
          }

          .benefit-cell {
            font-size: 10px;
            padding: 6px 4px;
          }
        }
      `}</style>

      {/* ================= BANNER ================= */}

      <div className="w-full overflow-hidden">
        <Slider {...bannerSettings}>
          {banners.map((banner, index) => (
            <div key={index}>
              <div className="border-[3px] border-[#35A93E] h-full">
                <img
                  src={banner.url}
                  alt={`LifeOnPlus banner ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* ================= TRUST BAR ================= */}

      <div className="bg-white py-4 border-b">
        <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-center gap-8 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <FaShieldAlt />
            100% Secure Payment
          </div>

          <div className="flex items-center gap-2">
            <FaAward />
            ISO Certified
          </div>

          <div className="flex items-center gap-2">
            <FaUsers />
            10,000+ Happy Customers
          </div>
        </div>
      </div>

      {/* ================= COMPANY LOGOS ================= */}

      <div className="container-fluid mx-auto max-w-7xl my-5">
        <Slider {...settings}>
          {companies.map((item, index) => (
            <div key={index}>
              <img
                src={item.imgSrc}
                alt="LifeOnPlus company"
                width={100}
                height={50}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* ===================================================== */}
      {/* ================= PRIME CATEGORIES ================== */}
      {/* ===================================================== */}

      <section className="bg-white py-14">
        <div className="max-w-7xl mx-auto px-4">

          {/* Heading */}

          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Prime Categories
            </h2>

            <p className="text-gray-600 mt-3">
              Check Out Our Trusted Medical Supplies
            </p>

            <div className="flex justify-center mt-4">
              <div className="h-1 w-14 rounded-full bg-[#35A93E]" />
            </div>
          </div>

          {/* ================= FOUR PRIME CATEGORIES ================= */}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

            {primeCategories.map((category, index) => (
              <div
                key={index}
                onClick={() => navigate(category.link)}
                className="prime-category-card group bg-white rounded-2xl border border-gray-200 overflow-hidden cursor-pointer hover:shadow-xl"
              >

                {/* Image */}

                <div className="h-52 bg-gray-50 overflow-hidden flex items-center justify-center">

                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-contain p-5 group-hover:scale-105 transition-transform duration-500"
                  />

                </div>

                {/* Content */}

                <div className="p-5 text-center">

                  <h3 className="text-lg font-bold text-gray-900">
                    {category.title}
                  </h3>

                  <p className="text-sm text-[#35A93E] font-medium mt-2">
                    {category.products}
                  </p>

                  <div className="mt-3 text-sm font-medium text-gray-500 group-hover:text-[#35A93E] transition">
                    Explore Now →
                  </div>

                </div>

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= ABOUT ================= */}

      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">

          <div>

            <h2 className="text-4xl font-bold mb-6">
              About LifeOnPlus
            </h2>

            <p className="text-gray-600 leading-relaxed text-lg">
              We are pioneers in Digital Health Technology, combining
              innovative medical devices with advanced digital solutions
              to make healthcare accessible, affordable, and intelligent
              for everyone.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-6 text-center">

              <div>
                <div className="text-3xl font-bold text-[#35A93E]">
                  10+
                </div>

                <div className="text-sm text-gray-500">
                  Verticals
                </div>
              </div>

              <div>
                <div className="text-3xl font-bold text-[#35A93E]">
                  6
                </div>

                <div className="text-sm text-gray-500">
                  Countries
                </div>
              </div>

              <div>
                <div className="text-3xl font-bold text-[#35A93E]">
                  30+
                </div>

                <div className="text-sm text-gray-500">
                  Partners
                </div>
              </div>

            </div>

          </div>

          <div className="border-[3px] border-[#35A93E] h-full">

            <img
              src="/banner24.jpeg"
              alt="About Us"
              className="w-full h-full object-cover"
            />

          </div>

        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}

      <section className="bg-white py-16">

        <div className="max-w-7xl mx-auto px-4">

          <h2 className="text-4xl font-bold text-center mb-12">
            Why Choose LifeOnPlus?
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

            {[
              {
                icon: <FaGlobe size={50} />,
                title: "Global Standards",
                desc: "ISO certified & HIPAA compliant technology",
              },
              {
                icon: <FaBatteryFull size={50} />,
                title: "Advanced Technology",
                desc: "Latest medical devices with digital integration",
              },
              {
                icon: <FaShieldAlt size={50} />,
                title: "Secure & Reliable",
                desc: "Your health data is protected with strong security",
              },
              {
                icon: <FaUsers size={50} />,
                title: "Expert Support",
                desc: "24/7 dedicated customer care & technical support",
              },
            ].map((item, index) => (

              <div
                key={index}
                className="text-center p-8 rounded-3xl border hover:shadow-xl transition"
              >

                <div className="flex justify-center mb-6">

                  <div className="w-20 h-20 flex items-center justify-center text-[#35A93E] bg-green-50 rounded-2xl">
                    {item.icon}
                  </div>

                </div>

                <h3 className="font-semibold text-lg mb-3">
                  {item.title}
                </h3>

                <p className="text-sm text-gray-600">
                  {item.desc}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= PROFESSIONAL MEMBERSHIP ================= */}

      <section className="relative py-8 md:py-10 bg-[#f8faf9] overflow-hidden">

        <div className="absolute top-0 left-0 w-full h-1 bg-[#35A93E]" />

        <div className="max-w-6xl mx-auto px-4">

          <div className="text-center mb-5">

            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border border-green-100 shadow-sm">

              <span className="w-1.5 h-1.5 rounded-full bg-[#35A93E]" />

              <span className="text-[#35A93E] text-[10px] sm:text-xs font-bold uppercase tracking-[0.12em]">
                Membership Plans
              </span>

            </div>

            <h2 className="mt-2 text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight">
              Choose Your Membership
            </h2>

            <p className="mt-1.5 text-xs sm:text-sm text-gray-500 max-w-lg mx-auto">
              Select a membership plan and get started with LifeOnPlus.
            </p>

            <div className="flex justify-center mt-2">
              <div className="h-0.5 w-10 rounded-full bg-[#35A93E]" />
            </div>

          </div>

          {/* ================= MEMBERSHIP CARDS ================= */}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 max-w-4xl mx-auto">

            {membershipPlans.map((plan, index) => (

              <div
                key={index}
                className="membership-card group relative bg-white rounded-md border border-gray-200 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_6px_15px_rgba(0,0,0,0.08)]"
              >

                <div
                  className="h-0.5 w-full"
                  style={{ backgroundColor: plan.color }}
                />

                <div className="membership-content px-2.5 py-2.5">

                  <div className="text-center">

                    <div
                      className="mx-auto w-6 h-6 rounded-md flex items-center justify-center text-[9px] font-bold"
                      style={{
                        backgroundColor: plan.light,
                        color: plan.color,
                      }}
                    >
                      {index + 1}
                    </div>

                    <h3 className="mt-1 text-xs font-extrabold text-gray-900 tracking-wide">
                      {plan.name}
                    </h3>

                    <div
                      className="mx-auto mt-1 h-0.5 w-4 rounded-full"
                      style={{ backgroundColor: plan.color }}
                    />

                  </div>

                  <div className="text-center mt-2">

                    <span className="text-lg md:text-xl font-extrabold tracking-tight text-gray-900">
                      {plan.price}
                    </span>

                  </div>

                  <div className="mt-2">

                    <button
                      type="button"
                      onClick={() => {
                        window.location.href = "/signup/member";
                      }}
                      className="membership-button w-full h-7 rounded-md text-white text-[9px] font-bold flex items-center justify-center shadow-sm hover:shadow-md"
                      style={{
                        backgroundColor: plan.color,
                      }}
                    >
                      Get Started
                    </button>

                  </div>

                </div>

              </div>

            ))}

          </div>

          {/* ================= MEMBERSHIP BENEFITS ================= */}

          <section className="mt-6">

            <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

              <div className="bg-[#123b7a] text-white text-center py-2.5">

                <h3 className="text-base md:text-lg font-bold">
                  BENEFITS COMPARISON
                </h3>

              </div>

              <div className="benefit-wrapper">

                <table className="benefit-table border-collapse">

                  <thead>

                    <tr className="bg-gray-50">

                      <th className="benefit-cell text-left font-bold w-[35%]">
                        BENEFITS
                      </th>

                      {membershipPlans.map((plan) => (

                        <th
                          key={plan.name}
                          className="benefit-cell text-center"
                          style={{ color: plan.color }}
                        >

                          <div className="font-bold text-xs">
                            {plan.name}
                          </div>

                          <div className="font-bold text-sm">
                            {plan.price}
                          </div>

                          <div className="text-[8px] text-gray-500">
                            PER YEAR
                          </div>

                        </th>

                      ))}

                    </tr>

                  </thead>

                  <tbody>

                    {/* DIGITAL HEALTH IDENTITY */}

                    <tr>
                      <td
                        colSpan="5"
                        className="benefit-cell bg-green-50 text-[#35A93E] font-bold text-left"
                      >
                        DIGITAL HEALTH IDENTITY
                      </td>
                    </tr>

                    {[
                      "Digital Emergency Health Kit",
                      "Digital Card with Photo ID",
                      "NFC Card with Photo ID",
                      "ABHA - National Health Authority",
                    ].map((item) => (

                      <tr key={item}>

                        <td className="benefit-cell font-medium text-left">
                          {item}
                        </td>

                        <td className="benefit-cell text-center text-[#35A93E] font-bold">
                          ✓
                        </td>

                        <td className="benefit-cell text-center text-[#35A93E] font-bold">
                          ✓
                        </td>

                        <td className="benefit-cell text-center text-[#35A93E] font-bold">
                          ✓
                        </td>

                        <td className="benefit-cell text-center text-[#35A93E] font-bold">
                          ✓
                        </td>

                      </tr>

                    ))}

                    {/* ONE TOUCH SERVICES */}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell bg-blue-50 text-[#123b7a] font-bold text-left"
                      >
                        ONE TOUCH - SERVICES
                      </td>

                    </tr>

                    {[
                      [
                        "Emergency Health Report Button",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "Rescue Button (GPS/SMS/Call)",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "Emergency Health Button (GPS/SMS/Call)",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "GPS Live Tracking Ambulance Button",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "One Touch Police",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "One Touch Fire",
                        "5",
                        "10",
                        "15",
                        "30",
                      ],
                      [
                        "One Touch - Smart Reminder",
                        "Unlimited",
                        "Unlimited",
                        "Unlimited",
                        "Unlimited",
                      ],
                      [
                        "One Touch - Dr. Consultation",
                        "✕",
                        "✕",
                        "One Time",
                        "Two Times",
                      ],
                    ].map((row, index) => (

                      <tr key={index}>

                        {row.map((cell, cellIndex) => (

                          <td
                            key={cellIndex}
                            className={`benefit-cell ${
                              cellIndex === 0
                                ? "font-medium text-left"
                                : "text-center font-semibold"
                            }`}
                          >
                            {cell}
                          </td>

                        ))}

                      </tr>

                    ))}

                    {/* MEDICAL TESTS */}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell bg-blue-50 text-[#123b7a] font-bold text-left"
                      >
                        COMPLIMENTARY MEDICAL TESTS
                      </td>

                    </tr>

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell font-bold text-left text-gray-700"
                      >
                        INVASIVE - NABL - APPROVED LABS
                      </td>

                    </tr>

                    {[
                      [
                        "CBC",
                        "One Time",
                        "One Time",
                        "Two Times",
                        "Two Times",
                      ],
                      [
                        "Lipid profile or any alternative tests",
                        "✕",
                        "✕",
                        "✕",
                        "One Time",
                      ],
                    ].map((row, index) => (

                      <tr key={index}>

                        {row.map((cell, cellIndex) => (

                          <td
                            key={cellIndex}
                            className={`benefit-cell ${
                              cellIndex === 0
                                ? "font-medium text-left"
                                : "text-center font-semibold"
                            }`}
                          >
                            {cell}
                          </td>

                        ))}

                      </tr>

                    ))}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell font-bold text-left text-gray-700"
                      >
                        NON INVASIVE
                      </td>

                    </tr>

                    {[
                      [
                        "Heart Health (Artery Blockage)",
                        "✕",
                        "One Time",
                        "One Time",
                        "One Time",
                      ],
                      [
                        "Advanced ECG",
                        "✕",
                        "One Time",
                        "One Time",
                        "One Time",
                      ],
                      [
                        "Antioxidant Measurement Test",
                        "✕",
                        "One Time",
                        "One Time",
                        "Two Times",
                      ],
                    ].map((row, index) => (

                      <tr key={index}>

                        {row.map((cell, cellIndex) => (

                          <td
                            key={cellIndex}
                            className={`benefit-cell ${
                              cellIndex === 0
                                ? "font-medium text-left"
                                : "text-center font-semibold"
                            }`}
                          >
                            {cell}
                          </td>

                        ))}

                      </tr>

                    ))}

                    {/* AI */}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell bg-red-50 text-red-600 font-bold text-left"
                      >
                        AI (CONTACTLESS) COMING SOON
                      </td>

                    </tr>

                    {[
                      [
                        "6 Tests - 30 Plus",
                        "6 Tests",
                        "6 Tests",
                        "6 Tests",
                        "6 Tests",
                      ],
                      [
                        "Dedicated Tests from NABL-Labs",
                        "✕",
                        "✕",
                        "2 Tests",
                        "6 Tests",
                      ],
                    ].map((row, index) => (

                      <tr key={index}>

                        {row.map((cell, cellIndex) => (

                          <td
                            key={cellIndex}
                            className={`benefit-cell ${
                              cellIndex === 0
                                ? "font-medium text-left"
                                : "text-center font-semibold"
                            }`}
                          >
                            {cell}
                          </td>

                        ))}

                      </tr>

                    ))}

                    {/* OTHER BENEFITS */}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell bg-green-50 text-[#35A93E] font-bold text-left"
                      >
                        OTHER BENEFITS
                      </td>

                    </tr>

                    <tr>

                      <td className="benefit-cell font-medium text-left">
                        Renewal Yearly
                      </td>

                      <td className="benefit-cell text-center text-[#35A93E] font-bold">
                        ✓
                      </td>

                      <td className="benefit-cell text-center text-[#35A93E] font-bold">
                        ✓
                      </td>

                      <td className="benefit-cell text-center text-[#35A93E] font-bold">
                        ✓
                      </td>

                      <td className="benefit-cell text-center text-[#35A93E] font-bold">
                        ✓
                      </td>

                    </tr>

                    {/* VALUE ADDED SERVICES */}

                    <tr>

                      <td
                        colSpan="5"
                        className="benefit-cell bg-[#123b7a] text-white font-bold text-center"
                      >
                        VALUE ADDED SERVICES & DISCOUNTS %
                      </td>

                    </tr>

                    {[
                      [
                        "App / Web - based Products / Services",
                        "10% OFF",
                        "15% OFF",
                        "20% OFF",
                        "25% OFF",
                      ],
                      [
                        "Labs Test",
                        "10% OFF",
                        "15% OFF",
                        "20% OFF",
                        "25% OFF",
                      ],
                      [
                        "Hospital Test",
                        "10% OFF",
                        "15% OFF",
                        "20% OFF",
                        "25% OFF",
                      ],
                      [
                        "Digital Health Studio - Services",
                        "10% OFF",
                        "15% OFF",
                        "20% OFF",
                        "25% OFF",
                      ],
                    ].map((row, index) => (

                      <tr key={index}>

                        {row.map((cell, cellIndex) => (

                          <td
                            key={cellIndex}
                            className={`benefit-cell ${
                              cellIndex === 0
                                ? "font-medium text-left"
                                : "text-center font-bold"
                            }`}
                          >
                            {cell}
                          </td>

                        ))}

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

              {/* ONE MEMBERSHIP MANY BENEFITS */}

              <div className="p-4 md:p-5 border-t">

                <div className="bg-[#123b7a] text-white text-center py-2.5 rounded-lg">

                  <h4 className="font-bold text-base md:text-lg">
                    ONE MEMBERSHIP – MANY BENEFITS
                  </h4>

                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-2.5 md:gap-3 mt-4">

                  {[
                    {
                      icon: "💊",
                      title: "Digital Emergency Health Kit",
                    },
                    {
                      icon: "💳",
                      title: "Digital & NFC Health Card",
                    },
                    {
                      icon: "🏥",
                      title: "ABHA Integrated",
                    },
                    {
                      icon: "🚨",
                      title: "One Touch Emergency Services",
                    },
                    {
                      icon: "🚑",
                      title: "GPS Ambulance Live Tracking",
                    },
                    {
                      icon: "🛡️",
                      title: "Police & Fire Assistance",
                    },
                    {
                      icon: "👨‍⚕️",
                      title: "Doctor Consultation",
                    },
                    {
                      icon: "❤️",
                      title: "Preventive Health Tests",
                    },
                    {
                      icon: "🔬",
                      title: "NABL Approved Lab Tests",
                    },
                    {
                      icon: "🤖",
                      title: "AI Contactless Technology",
                    },
                  ].map((item, index) => (

                    <div
                      key={index}
                      className="border border-gray-200 rounded-lg p-2 bg-white hover:shadow-md transition text-center"
                    >

                      <div className="w-9 h-9 mx-auto rounded-lg bg-gray-50 flex items-center justify-center text-lg mb-1.5">
                        {item.icon}
                      </div>

                      <p className="text-[10px] md:text-[11px] font-semibold text-gray-700 leading-3.5">
                        {item.title}
                      </p>

                    </div>

                  ))}

                </div>

              </div>

            </div>

          </section>

        </div>

      </section>

      {/* ================= AI HEALTHCARE SERVICES ================= */}

      <section className="py-16 bg-white">

        <div className="max-w-7xl mx-auto px-4">

          <div className="text-center mb-10">

            <span className="inline-block bg-orange-100 text-orange-600 px-4 py-1 rounded-full text-sm font-semibold">
              🚀 Launching Soon
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-4">
              AI-Powered Healthcare Services
            </h2>

            <p className="text-gray-600 mt-3 max-w-3xl mx-auto">
              We're introducing intelligent AI healthcare solutions to
              help members receive faster guidance, smarter
              recommendations, and enhanced digital healthcare
              experiences.
            </p>

          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-center">

            <div>

              <div className="space-y-5">

                <div className="flex gap-4">

                  <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center text-2xl">
                    🤖
                  </div>

                  <div>

                    <h4 className="font-semibold text-lg">
                      AI Healthcare Assistant
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      Website & WhatsApp chatbot providing 24×7
                      health-related assistance.
                    </p>

                  </div>

                </div>

                <div className="flex gap-4">

                  <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center text-2xl">
                    📋
                  </div>

                  <div>

                    <h4 className="font-semibold text-lg">
                      AI Prescription Assistant
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      AI-assisted prescription suggestions based on
                      symptoms and medical history.
                    </p>

                  </div>

                </div>

                <div className="flex gap-4">

                  <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center text-2xl">
                    🧠
                  </div>

                  <div>

                    <h4 className="font-semibold text-lg">
                      AI Health Recommendations
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      Personalized health insights, wellness guidance,
                      and preventive care recommendations.
                    </p>

                  </div>

                </div>

                <div className="flex gap-4">

                  <div className="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center text-2xl">
                    🩺
                  </div>

                  <div>

                    <h4 className="font-semibold text-lg">
                      AI Body Screening
                    </h4>

                    <p className="text-gray-600 text-sm mt-1">
                      AI-powered body screening with analysis of
                      multiple vital health parameters for early
                      health insights.
                    </p>

                  </div>

                </div>

              </div>

            </div>

            <div className="relative">

              <div className="rounded-3xl overflow-hidden shadow-xl border border-gray-200">

                <img
                  src="/ai-healthcare-coming-soon.png"
                  alt="AI Healthcare Services"
                  className="w-full"
                />

              </div>

              <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full font-semibold shadow-lg">
                Launching Soon
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= HOW IT WORKS ================= */}

      <section className="py-20">

        <div className="max-w-7xl mx-auto px-4">

          <div className="text-center mb-16">

            <h2 className="text-4xl font-bold">
              How LifeOnPlus Works
            </h2>

            <p className="text-gray-600 mt-4">
              Get started in just a few simple steps.
            </p>

          </div>

          <div className="grid md:grid-cols-5 gap-8 text-center">

            {[
              {
                no: "01",
                title: "Register",
                desc: "Create your LifeOnPlus account.",
              },
              {
                no: "02",
                title: "Complete Profile",
                desc: "Add your healthcare information securely.",
              },
              {
                no: "03",
                title: "Choose Membership",
                desc: "Select a suitable healthcare plan.",
              },
              {
                no: "04",
                title: "Access Services",
                desc: "Book healthcare services anytime.",
              },
              {
                no: "05",
                title: "Stay Healthy",
                desc: "Track and manage your digital health.",
              },
            ].map((step, index) => (

              <div
                key={index}
                className="relative bg-white rounded-2xl shadow-md p-4 hover:shadow-xl transition"
              >

                <div className="w-12 h-12 rounded-full bg-[#35A93E] text-white flex items-center justify-center mx-auto text-lg font-bold mb-3">
                  {step.no}
                </div>

                <h3 className="font-bold text-base mb-3">
                  {step.title}
                </h3>

                <p className="text-gray-600 text-xs">
                  {step.desc}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= ACCOUNT ACCESS ================= */}

      <section className="py-14 bg-gray-50">

        <div className="max-w-7xl mx-auto px-4">

          <div className="text-center mb-8">

            <span className="text-[#35A93E] text-sm font-semibold uppercase tracking-wider">
              Get Started
            </span>

            <h2 className="text-3xl md:text-4xl font-bold mt-2">
              Access Your LifeOnPlus Account
            </h2>

            <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto mt-3">
              Click the <strong>Account</strong> button in the
              top-right corner to register or log in as a Member,
              Partner, Corporate, Vendor, Franchise, Director, or
              End User.
            </p>

          </div>

          <div className="grid md:grid-cols-3 gap-4 mb-6">

            {[
              {
                icon: <FaMousePointer />,
                title: "Click Account",
                desc: "Open the Account menu from the header.",
              },
              {
                icon: <FaUserCheck />,
                title: "Select Role",
                desc: "Choose your preferred account type.",
              },
              {
                icon: <FaSignInAlt />,
                title: "Register / Login",
                desc: "Complete registration or sign in.",
              },
            ].map((step) => (

              <div
                key={step.title}
                className="bg-white border border-gray-200 rounded-xl p-4 flex items-start gap-4 hover:shadow-sm transition"
              >

                <div className="w-10 h-10 rounded-full bg-[#35A93E] text-white flex items-center justify-center font-semibold flex-shrink-0">
                  {step.icon}
                </div>

                <div>

                  <h3 className="text-base font-semibold text-gray-900">
                    {step.title}
                  </h3>

                  <p className="mt-1 text-sm text-gray-600 leading-5">
                    {step.desc}
                  </p>

                </div>

              </div>

            ))}

          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

            {roles.map((role, index) => (

              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-4 hover:shadow-md hover:border-[#35A93E] transition-all"
              >

                <div className="flex items-center gap-3 mb-2">

                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0"
                    style={{
                      backgroundColor: role.bg,
                      color: role.color,
                    }}
                  >
                    {role.icon}
                  </div>

                  <h4 className="font-semibold text-gray-900 text-[15px] leading-5">
                    {role.title}
                  </h4>

                </div>

                <p className="text-xs text-gray-600 leading-6">
                  {role.desc}
                </p>

              </div>

            ))}

          </div>

          <div className="text-center mt-8">

            <button
              onClick={openAccountModal}
              className="bg-[#35A93E] hover:bg-[#2d9436] text-white px-8 py-3 rounded-lg font-medium transition"
            >
              Register / Login
            </button>

            <p className="text-sm text-gray-500 mt-3">
              Opens the Account window where you can choose your role
              and continue.
            </p>

          </div>

        </div>

      </section>

      {/* ================= POPULAR SERVICES ================= */}

      <section className="max-w-7xl mx-auto px-4 py-16">

        <div className="text-center mb-12">

          <h2 className="text-4xl font-bold text-gray-900">
            Our Popular Services
          </h2>

          <p className="text-gray-600 mt-3">
            Innovative health solutions for a better life
          </p>

        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {services.map((service, index) => (

            <div
              key={index}
              onClick={() => navigate(service.link)}
              className="group bg-white border border-gray-100 rounded-3xl overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >

              <div className="h-60 bg-gray-100 relative overflow-hidden">

                <img
                  src={service.img}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />

              </div>

              <div className="p-2.5">

                <h3 className="font-semibold text-xl text-gray-900 mb-2 line-clamp-2">
                  {service.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-2">
                  {service.desc}
                </p>

                <div className="text-[#35A93E] font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
                  Explore Now →
                </div>

              </div>

            </div>

          ))}

        </div>

        <div className="flex justify-center mt-10">

          <button
            onClick={() => navigate("/services")}
            className="bg-[#35A93E] hover:bg-[#2d9436] text-white px-8 py-3 rounded-xl font-medium transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
          >
            Explore All Services
            <span>→</span>
          </button>

        </div>

      </section>

      {/* ================= TESTIMONIAL ================= */}

      <section
        id="testimonial-section"
        className="bg-[#fcf5ef] py-5 mt-5 md:py-5"
      >

        <div className="mx-auto px-4">

          <div className="flex flex-col sm:flex-row gap-5 justify-between sm:items-center">

            <h2 className="text-xl sm:text-xl md:text-3xl lg:text-4xl font-semibold mb-3 md:mb-4">
              Testimonial
            </h2>

          </div>

          <p className="text-lg font-medium mb-3 max-w-2xl">
            What others say about lifeonplus.
          </p>

          <div className="testimonial-slider">

            <Slider {...settings2}>

              {testimonial.map((items, index) => (

                <div key={index} className="px-3">

                  <div className="testimonial-card bg-white p-4 md:p-10 rounded-2xl shadow-sm flex flex-col min-h-[300px]">

                    <div className="flex justify-center mb-3">

                      <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-white shadow-md bg-white flex items-center justify-center">

                        <img
                          src={items.imgSrc}
                          alt={items.name}
                          className="w-full h-full object-cover"
                        />

                      </div>

                    </div>

                    <div className="flex-1 flex flex-col text-center">

                      <p className="text-xs text-gray-500 mb-1">
                        {items.profession}
                      </p>

                      <p className="text-base font-semibold mb-2">
                        {items.name}
                      </p>

                      <p className="text-xs leading-relaxed text-gray-700 flex-1">
                        {items.detail}
                      </p>

                    </div>

                  </div>

                </div>

              ))}

            </Slider>

          </div>

        </div>

      </section>

      {/* ================= FAQ ================= */}

      <section className="bg-white py-16">

        <div className="max-w-7xl mx-auto px-4">

          <div className="text-center mb-12">

            <h2 className="text-4xl font-bold text-gray-900">
              Frequently Asked Questions
            </h2>

            <p className="text-gray-600 mt-3">
              Quick answers to common questions
            </p>

          </div>

          <div className="space-y-4">

            {faqs.map((faq, index) => (

              <details
                key={index}
                className="group bg-white border border-gray-200 rounded-2xl px-3 py-3 cursor-pointer hover:shadow-md transition-all"
              >

                <summary className="flex justify-between items-center text-lg font-medium text-gray-900 list-none">

                  {faq.q}

                  <span className="text-2xl text-gray-400 group-open:rotate-45 transition-transform">
                    +
                  </span>

                </summary>

                <p className="text-gray-600 mt-4 leading-relaxed">
                  {faq.a}
                </p>

              </details>

            ))}

          </div>

          <div className="text-center mt-10">

            <button
              onClick={() => navigate("/faq")}
              className="text-[#35A93E] font-medium hover:underline"
            >
              View All FAQs →
            </button>

          </div>

        </div>

      </section>

      {/* ================= CONTACT CTA ================= */}

      <section className="py-16 bg-[#35A93E] text-white">

        <div className="max-w-5xl mx-auto px-4 text-center">

          <h2 className="text-3xl md:text-4xl font-bold">
            Have Questions? Let's Talk.
          </h2>

          <p className="mt-4 text-green-100 max-w-2xl mx-auto leading-7">
            Our team is here to help you with memberships, healthcare
            services, partnerships, and any questions about LifeOnPlus.
            We'd love to hear from you.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 bg-white text-[#35A93E] px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition"
          >
            Contact Us
          </button>

        </div>

      </section>

      {/* ================= VIDEO MODAL ================= */}

      {selectedVideo && (

        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4"
          onClick={() => setSelectedVideo(null)}
        >

          <div
            className="relative w-full max-w-3xl bg-black rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-3 right-3 z-10 w-10 h-10 flex items-center justify-center bg-black/50 text-white text-2xl rounded-full hover:bg-black/70 transition"
            >
              ✕
            </button>

            <video
              src={selectedVideo}
              controls
              autoPlay
              className="w-full max-h-[80vh] object-contain"
            />

          </div>

        </div>

      )}

    </>
  );
};

export default Home;